import { Navigate, Outlet } from "react-router-dom";
import ERoutes from "types/Routes";
import styles from "./styles.module.scss";
import { useAppSelector } from "hooks/store";
import { selectIsAuthenticated } from "store/auth/authSlice";

const UserManagementLayout = () => {

  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return isAuthenticated ? (
    <Navigate to={ERoutes.Home} replace />
  ) : (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        position: 'relative',
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Outlet />
      </div> 
      <div
          className="footer"
          style={{
            padding: '10px 15px',
            backgroundColor: '#ffffff',
            textAlign: 'center',
            fontSize: 14,
            color: 'rgba(000,000,000, 0.6)',
          }}
        >
          &copy; 2024- {new Date().getFullYear()} VinDrives. All Rights Reserved.
        </div>
    </div>
  );
};
export default UserManagementLayout;
